import { useState, useCallback, ChangeEvent } from "react"

function toFloat(value: string): number | undefined {
    const parsed = Number.parseFloat(value)

    return Number.isNaN(parsed) ? undefined : parsed
}

function toString(value: number | undefined): string {
    return Number.isNaN(value) || value === undefined ? "" : String(value)
}

/**
 * Returns a padded value to display
 *
 * @return [float, displayValue, setNumber, setNumberFromInputChangeEvent]
 */
export function useFloat(
    initialNumber: number | undefined
): [
    number | undefined,
    string,
    (value: string) => number | undefined,
    (event: ChangeEvent<HTMLInputElement>) => void
] {
    const [displayValue, setDisplayValue] = useState(toString(initialNumber))
    const float = toFloat(displayValue)
    const setNumber = useCallback((value: string) => {
        setDisplayValue(value)

        return toFloat(value)
    }, [])

    const setNumberFromInputChangeEvent = useCallback(
        (e: ChangeEvent<HTMLInputElement>) => setDisplayValue(e.target.value),
        []
    )

    return [float, displayValue, setNumber, setNumberFromInputChangeEvent]
}
